import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const services = [
    { title: "Cab Services", path: "/cab-services", feats: ["Airport Transfers", "Corporate Travel", "City Tours", "Long Distance"] },
    { title: "Real Estate Services", path: "/real-estate", feats: ["Office Leasing", "Residential Apartments", "Property Management", "Relocation Assistance"] },
    { title: "Business Setup Services", path: "/business-setup", feats: ["Company Registration", "Legal Documentation", "Compliance Support", "HR & Recruitment"] },
    { title: "Packers & Movers", path: "/packers-movers", feats: ["Local & Long Distance Moving", "Packing Services", "Relocation Support", "Storage Solutions"] },
    { title: "Company Registration", path: "/registration", feats: ["Complete assistance for company incorporation", "Legal documentation"] },
    { title: "Compliance & Government Approvals", path: "/compliance", feats: ["Support for licenses", "Registrations", "Regulatory compliance"] },
    {
        title: "Organic Magnetic Pyrolysis System",
        path: "/pyrolysis-system",
        feats: [
            "Eco-friendly waste decomposition",
            "24/7 automatic operation",
            "Converts waste to steam & energy",
            "No fossil fuels required"
        ]
    },
    {
        title: "JLPT Course (Agra)",
        path: "/jlpt-course",
        feats: ["N5 to N1 Levels", "Online & Offline", "Job Placement Support"]
    }
];

const ServicesPage = () => (
    <div className="min-h-screen bg-fixed bg-center bg-cover" style={{ backgroundImage: "url('/city-background.jpg')" }}>
        <div className="bg-gray-50/90 min-h-screen">
            <Navbar />

            {/* Banner Section */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="h-[400px] flex items-center justify-center text-white relative bg-cover bg-center"
                style={{ backgroundImage: "url('/about-banner.jpg')" }}
            >
                <div className="absolute inset-0 bg-black/50" />
                <h1 className="relative text-5xl md:text-6xl font-bold z-10">Our Services</h1>
            </motion.div>

            <div className="max-w-7xl mx-auto px-6 py-16">

                {/* Highlight Boxes */}
                <div className="grid md:grid-cols-3 gap-8 mb-20 text-center">
                    {[
                        { t: "Reliable Car Rental", d: "Well-maintained vehicles ensuring safe corporate travel." },
                        { t: "Verified Property Leasing", d: "Trusted properties with complete documentation." },
                        { t: "Professional & Transparent", d: "Clear processes and dedicated support." }
                    ].map((item, i) => (
                        <motion.div
                            key={i}
                            whileHover={{ scale: 1.05 }}
                            className="p-8 bg-white/80 backdrop-blur-sm shadow-lg rounded-xl border border-white/50 cursor-pointer"
                        >
                            <h3 className="font-bold text-xl mb-3 text-[#1a2b4d]">{item.t}</h3>
                            <p className="text-gray-700">{item.d}</p>
                        </motion.div>
                    ))}
                </div>

                {/* Services Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
                    {services.map((s, i) => (
                        <motion.div
                            key={i}
                            whileHover={{ y: -10 }}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md border-b-4 border-[#f15a24] hover:shadow-2xl transition-all"
                        >
                            <h3 className="text-2xl font-bold mb-4">{s.title}</h3>
                            <ul className="text-gray-700 space-y-2 mb-6 min-h-[120px]">
                                {s.feats.map((f, j) => <li key={j}>• {f}</li>)}
                            </ul>

                            <Link
                                to={s.path}
                                className="text-[#f15a24] font-bold hover:underline block py-3 px-4 md:px-0 md:inline-block border md:border-none border-[#f15a24] rounded-lg md:rounded-none mt-2 text-center"
                            >
                                Read more →
                            </Link>
                        </motion.div>
                    ))}
                </div>

                {/* Enquiry Now Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    className="text-center py-10"
                >
                    <h2 className="text-3xl font-bold text-[#1a2b4d] mb-6">Need a custom solution?</h2>
                    <Link to="/enquiry">
                        <button className="bg-[#f15a24] text-white px-10 py-4 rounded-lg font-bold hover:bg-[#d44d1e] transition uppercase tracking-wider text-xl shadow-xl">
                            ENQUIRE NOW
                        </button>
                    </Link>
                </motion.div>
            </div>
            <Footer />
        </div>
    </div>
);

export default ServicesPage;